<template>
  <div v-if="!isMaintenance" class="l-notifications">
    <div
      class="l-notifications-top"
      ref="notifications"
      :style="{ left: scrollX + 'px' }"
    >
      <ListItemNotification
        v-for="(item, index) in notifications"
        :key="index"
        :item="item"
        @toggle="updateHeight"
      />
      <GaGscInvalidNotification v-if="isInvalidGaGsc" @toggle="updateHeight" />
    </div>
    <div
      v-if="diffVersion && isActive"
      class="l-notifications-bottom"
      :style="{ left: scrollX + 'px' }"
    >
      <div class="l-notifications-bottom__inner">
        <div class="l-notifications-bottom__content">
          <p>古いバージョンの<br />アプリケーションです。</p>
        </div>
        <Button variant="border" size="w80" fsize="f11" @click="reload">
          <Icon variant="return_gn" :size="12" />
          リロード
        </Button>
      </div>
      <Button
        v-if="diffVersion === 'minor'"
        class="l-notifications-bottom__close"
        @click="hideReload"
      >
        <Icon variant="close_gy" :size="8" />
      </Button>
    </div>
    <div v-if="diffVersion === 'major'" class="l-notifications__bg"></div>
  </div>
</template>

<script>
import Button from '@/components/Button';
import Icon from '@/components/Icon';
import ListItemNotification from '@/components/notifications/ListItemNotification';
import GaGscInvalidNotification from '@/components/notifications/GaGscInvalidNotification';

export default {
  components: {
    Button,
    Icon,
    ListItemNotification,
    GaGscInvalidNotification
  },

  data() {
    return {
      scrollX: 0,
      windowW: 0,
      isActive: true
    };
  },

  computed: {
    diffVersion() {
      return this.$store.getters['view/diffVersion'];
    },
    notifications() {
      // cssのz-indexの関係でreverseしている
      return this.$store.getters['view/notifications'].slice().reverse();
    },
    version() {
      return this.$store.state.view.version.current;
    },
    isMaintenance() {
      return this.$store.getters['view/isMaintenance'];
    },
    project() {
      return this.$store.getters['view/project'];
    },
    isInvalidGaGsc() {
      return (
        this.project.isValidGaRefreshToken === '0' ||
        this.project.isValidGscRefreshToken === '0'
      );
    }
  },

  watch: {
    version: {
      handler() {
        // バージョンが変わったら、非表示にしたリロードをうながすやつを再度表示する
        this.showReload();
      }
    },
    notifications: {
      handler() {
        this.updateHeight();
      }
    },
    windowW: {
      handler() {
        this.updateHeight();
      }
    },
    isMaintenance: {
      handler() {
        this.updateHeight();
      }
    },
    isInvalidGaGsc: {
      handler() {
        this.updateHeight();
      }
    }
  },

  mounted() {
    this.handleScroll();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleResize() {
      this.windowW = window.innerWidth;
    },
    handleScroll() {
      this.scrollX = -window.scrollX;
    },
    hideReload() {
      this.isActive = false;
    },
    reload() {
      location.reload(true);
    },
    showReload() {
      this.isActive = true;
    },
    updateHeight() {
      this.$nextTick(() => {
        let height = 0;
        if (this.$refs.notifications) {
          height = this.$refs.notifications.clientHeight;
        }
        this.$store.dispatch('view/setSize', {
          notificationsHeight: height
        });
        document.documentElement.style.setProperty(
          '--height-notifications',
          height + 'px'
        );
      });
    }
  }
};
</script>
